const firebaseConfig = {
  apiKey: "AIzaSyC9uoKSlJdC-LiU76IOocDUTwS_R-h-VcM",
  authDomain: "creative-agency-70516.firebaseapp.com",
  databaseURL: "https://creative-agency-70516.firebaseio.com",
  projectId: "creative-agency-70516",
  storageBucket: "creative-agency-70516.appspot.com",
  messagingSenderId: "36357579382",
  appId: "1:36357579382:web:778108a47f20b0c2337557",
};

export default firebaseConfig;
